<template>
<div>
    <div id="not-found" class="container">
        <h1>Page not found</h1>
        <p>
            The page you are trying to get doesn't seem to exist 
            or has migrated to a parallel universe.
        </p>
        <p>Try going back to the previous page and repeating your action.</p>
    </div>
</div>
</template>

<script>

export default {
    name: "NotFound",
}
</script>

<style lang="less" scoped>
#not-found {
    padding-top: 110px;
}
</style>